module.exports = "<router-outlet></router-outlet>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/main/main.component.html
// module id = 210
// module chunks = 1